import axios from '../utils/axios';


/**
 * 管理人里面的个人中心
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function invenstemInManagerInfo(data, au) {
  return axios('/ttd-fund-user/relation/invenstemInManagerInfo', data, au);
}
/**
 * 投资者合并数据到税收模板文件
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function mergeTxtInfoToDocs(data, au) {
  return axios('/ttd-fund-user/investorSigningTaxDocs/mergeTxtInfoToDocs', data, au);
}
